import React, { useEffect, useState, useContext} from 'react'
import firebase from '../config/firebase.js';
import { AuthContext } from '../Auth.js'


import { Grid } from '@material-ui/core';
import EmojiPeopleIcon from '@material-ui/icons/EmojiPeople';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';




function Turn (payload) { 
    const [voluntarios, setVoluntarios] = useState(null);
    const [userEnTurno, setUserEnTurno] = useState(false);
    const [turno, setTurno] = useState({})
    const {currentUser, userProfile} = useContext(AuthContext);
   
    const SumarVoluntariado = (turnoData) => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      
      const uidRef = db.collection('users').doc(currentUser.uid)
      const id = payload.diaId + "_" + payload.turnoId
      const volTurnoRef = uidRef.collection('turnos').doc(id)
      const turno = {
        'fecha'   : payload.fecha,
        'turno'   : turnoData.horario,
        'created' : firebase.firestore.FieldValue.serverTimestamp(),
        'verificado' : false
      }

      const turnoRef = db.collection('dias').doc(payload.diaId).collection('turnos').doc(payload.turnoId);
      const volRef = turnoRef.collection('voluntarios').doc(currentUser.uid);
      const voluntario = {
          'nombre'  : userProfile.nombre + " " + userProfile.apellido,
          'celular' : userProfile.celular,
          'email'   : userProfile.email,
          'cedula'  : userProfile.cedula,
          'created' : firebase.firestore.FieldValue.serverTimestamp(),
          'verificado' : false
      } 
     
            
      return firebase.firestore().runTransaction(function(transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(turnoRef).then(function(turnoDoc) {
              if (!turnoDoc.exists) {
                  throw "Turno  does not exist!";
              }
              transaction.set(volRef, voluntario);   
              transaction.set(volTurnoRef, turno);
            })
      }).then(function() {
      }).catch(function(error) {
          console.log("Transaction failed: ", error);
      });
    
    }

    const BajarVoluntariado = () => {
      const db = firebase.firestore().collection('orgs').doc('unidos');
      
      const uidRef = db.collection('users').doc(currentUser.uid)
      const id = payload.diaId + "_" + payload.turnoId
      const volTurnoRef = uidRef.collection('turnos').doc(id)
     
      const turnoRef = db.collection('dias').doc(payload.diaId).collection('turnos').doc(payload.turnoId);
      const volRef = turnoRef.collection('voluntarios').doc(currentUser.uid);
        
      var auditRef    = db.collection('audits').doc()
      var audit = {
          'userId'        : currentUser.uid,
          'userNombre'    : userProfile.nombre + " " + userProfile.apellido,
          'created'       : firebase.firestore.FieldValue.serverTimestamp(),
          'movimiento'    : "Baja Voluntario",
          'dia'           : payload.diaId, 
          'turno'         : payload.turnoId,
          'voluntarioId'  : currentUser.uid
      }

      return firebase.firestore().runTransaction(function(transaction) {
          // This code may get re-run multiple times if there are conflicts.
          return transaction.get(turnoRef).then(function(turnoDoc) {
              if (!turnoDoc.exists) {
                  throw "Turno  does not exist!";
              }
              transaction.delete(volRef);   
              transaction.delete(volTurnoRef);
              transaction.set(auditRef, audit);
            })
      }).then(function() {
      }).catch(function(error) {
          console.log("Transaction failed: ", error);
      });
    }

    useEffect(() => {
      const fetchData = async () => {
        const db = firebase.firestore().collection('orgs').doc('unidos');
        db.collection("dias")
        .doc(payload.diaId).collection('turnos').doc(payload.turnoId)
        .get()
        .then(function(doc) {
            if (doc.exists) {
                setTurno({...doc.data(), id:doc.id});
            } else {
                console.log("no existe")
            }

        });
     };

      const listenForVolunteers = () => {
              firebase.firestore().collection('orgs').doc('unidos')
                .collection('dias')
                .doc(payload.diaId).collection('turnos').doc(payload.turnoId)
                .collection('voluntarios')
                .onSnapshot((snapshot) => {
                  setUserEnTurno(false)
                  snapshot.docs.forEach(function(doc) {
                    if (doc.id === currentUser.uid)
                      setUserEnTurno(true)
                  });
                  setVoluntarios(snapshot.docs.map(x => ({...x.data(), id:x.id})));
              }, (error) => console.error(error));
     };
      fetchData();
      listenForVolunteers();  
    }, []);

    
    const renderAccion = (t) => {

      if (!userProfile.cedula || userProfile.cedula === "") {
        return (
          <>
          <Button disabled variant="outlined" color="secondary">
          <EmojiPeopleIcon />
          </Button>
          </>
        )
      }

      if (!userProfile.celular || userProfile.celular === "" || userProfile.celular.length !== 12) {
        return (
          <>
          <Button disabled variant="outlined" color="secondary">
          <EmojiPeopleIcon />
          </Button>
          </>
        )
      }

      if (userProfile.covid > 0) {
        return (
          <>
          <Button disabled variant="outlined" color="secondary">
          <EmojiPeopleIcon />
          </Button>
          </>
        )
      }
      if (voluntarios.length >= turno.maximo) { 
        if (userEnTurno) {
          return (
            <>
            <Tooltip title="Borrarme del turno" placement="left-start">
            <Button onClick={BajarVoluntariado} variant="contained" color="primary"> 
            <EmojiPeopleIcon />
            </Button>
            </Tooltip>
            </>
          );
        }
        return (
          <>
          <Button disabled variant="contained" color="default">
          <EmojiPeopleIcon />
          </Button>
          </>
          );
      }
      
      if (userEnTurno) {
        return (
          <>
          <Tooltip title="Borrarme del turno" placement="left-start">
          <Button onClick={BajarVoluntariado} variant="contained" color="primary"> 
          <EmojiPeopleIcon />
          </Button>
          </Tooltip>
          </>
        );
      } else {
          return (
          <>
          <Tooltip title="Sumarme al turno" placement="left-start">
          <Button onClick={() => SumarVoluntariado(turno)}  variant="contained" color="default">
          <EmojiPeopleIcon />
          </Button>
          </Tooltip>
          </>
          );
      };
    }

    const renderVoluntarios = (t) => {
      const maximo = turno.maximo;
      if (!voluntarios.length) {
        return (
          <div>
            No hay aún
          </div>
        )
      }
      if (userEnTurno) {
        return ( 
          <div>
              {voluntarios.length} de {maximo} ***
          </div>
        );  
      }
      return ( 
        <div>
            {voluntarios.length} de {maximo} 
        </div>
      );
    };

    // If the state is null we
    // know that it's still loading
    if (!voluntarios || !turno) {
      return (
      <div>
          Cargando...
      </div>
      )
    }

    if (!turno.bloqueado) {
      if (!turno.horario)
        return (<></>)
      return (
        <>
            <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
                <Grid xs item>
                <h4>{turno.horario}</h4>
                </Grid>
                <Grid xs item>
                {renderAccion(payload.turnoId)}
                </Grid>
                <Grid xs item>
                {renderVoluntarios(payload.turnoId)}
                 </Grid>
            </Grid>
        </>
      )
    }  else {
      return (
        <>
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
            <Grid xs item>
            <h4>{turno.horario}</h4>
            </Grid>
            <Grid xs item>
            <Button disabled color="secondary">
              <EmojiPeopleIcon />
            </Button>
            </Grid>
            <Grid xs item>
            {turno.bloqueante}
            </Grid>
        </Grid>
        </>
      )
    }

  
};
 

export default Turn; 
